import useJobFilterHook from "./use-job-filter-hook";


const JobHooks = {
    useFilter : useJobFilterHook
}

export default JobHooks;